import styled from 'vue-styled-components';

import { COLORS } from '@/styles/common.styled';
import { FLEX_COLUMN_DIV } from '@styles/common.styled.component';

export const Wrapper = styled(FLEX_COLUMN_DIV)`
    flex: 1;

    p.widget-error-panel__widget-title {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${COLORS['gray-100']};
        min-width: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    div.widget-error-panel__item {
        display: flex;
        flex-direction: column;
        margin-top: 18px;
        padding: 16px 16px 20px;
        background-color: ${COLORS['gray-10']};
        border-radius: 2px;

        .widget-error-panel__item__container {
            display: flex;
            align-items: start;
            gap: 8px;

            .widget-error-panel__icon_wrapper {
                width: 20px;
                height: 20px;
            }

            .widget-error-panel__item__text_wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 4px;
                padding-bottom: 12px;
                border-bottom: 1px solid #d9dee3;

                .widget-error-panel__item__title {
                    font-size: 13px;
                    font-weight: 500;
                    color: #4f5861;
                    word-break: keep-all;
                }
            }
        }

        .widget-error-panel__item__button-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 12px;

            button {
                height: 34px;
                min-width: 90px;
                padding: 0 12px;
                font-size: 13px;
                font-weight: 500;
            }

            & > button:last-child {
                margin-left: 28px;
            }
        }
    }
`;
